module.exports = __webpack_public_path__ + "img/slide22.23424ed7.png";